module.exports = __webpack_public_path__ + "images/tip-icon-d9d94eaf.svg";